import { Injectable } from '@angular/core';
import { AttributeStore, InventoryItem, Monster, Player, PlayerClass, PlayerSkill, Trap } from './models/models';


export enum loot_pools {
  Junk,
  Crude,
  Normal,
  Magic,
  Rare,

  Boss,
  Crystal
}


@Injectable({
  providedIn: 'root'
})
export class DataStoreService {

  ///level : tier
  tierBreakpoints: Record<number, number> = {
    0: 0,
    5: 1,
    15: 2,
    50: 3,
    100: 4,
    200: 5
  }


  Save() {
    localStorage.setItem('state', JSON.stringify({ players: this.players, inventory: this.inventory, gold: this.gold }));
  }

  Load() {
    if (this.players.length === 0) {
      let temp = localStorage.getItem('state');
      if (temp) {
        var parsed = JSON.parse(temp) || [];

        this.players = parsed.players;
        this.inventory = parsed.inventory;
        this.gold = parsed.gold || 0
        this.UpdateStats();
      }
    }
  }


  TierMultiplier(tier: number) {
    return tier;
  }


  UpdateStats() {
    this.players.forEach(element => {


      element.equipment_attributes = element.equipment.reduce((a, b) => {
        var eq = this.inventory_dictonary[b.name];
        if (eq.effect_equip !== undefined) {
          a.attack += (<any>eq.effect_equip.attack || 0) * this.TierMultiplier(b.tier)
          a.defense += (<any>eq.effect_equip.defense || 0) * this.TierMultiplier(b.tier)
          a.stamina += (<any>eq.effect_equip.stamina || 0) * this.TierMultiplier(b.tier)
          a.vitality += (<any>eq.effect_equip.vitality || 0) * this.TierMultiplier(b.tier)
        }
        return a;
      }, { attack: 0, defense: 0, stamina: 0, vitality: 0 })

      element.health_max = ((element.attributes.vitality || 0) + element.equipment_attributes.vitality) * 10;
      element.energy_max = ((element.attributes.stamina || 0) + element.equipment_attributes.stamina) * 10;

      element.equipment.sort((a, b) => a.name.localeCompare(b.name));

    });
  }


  IncrementInventory(name: string, tier: number) {
    var existing = this.inventory.find(x => x.name === name && x.tier == tier);
    if (existing)
      existing.quantity++;
    else {
      var open = this.inventory.find(x => x.name === undefined && x.quantity === 0);
      if (open) {
        open.name = name;
        open.quantity = 1;
        open.tier = tier;
      }
      else
        this.inventory.push({ name: name, tier: tier, quantity: 1 });
    }
  }


  gold: number = 0;
  inventory: { name?: string, tier: number, quantity: number }[] = [];
  players: Player[] = [];
  output: string = '';
  level: number = 1;
  rooms: number = 3;


  skills: PlayerSkill[] = [{
    name: 'Observe',
    description: 'Improve the ability recognize your surroundings or opponent',
    requirements: undefined,
    effect: {
      defense: 2
    }
  },
  {
    name: 'Powered Blow',
    description: 'Adds damage',
    requirements: {
    },
    effect: { attack: 2 }
  },
  {
    name: 'Mana Strike',
    description: 'Adds damage',
    requirements: {
    },

    effect: { attack: 2 }
  },
  {
    name: 'Find Weakness',
    description: '',
    requirements: {
    },
    effect: { attack: 1 }
  },
  {
    name: 'Target Weakness',
    description: '',
    requirements: {
    },
    effect: { attack: 2 }
  },
  {
    name: 'Athletics',
    description: '',
    requirements: {

    },
    effect: { stamina: 2 }
  },
  {
    name: 'Iron Skin',
    description: '',
    requirements: {

    },
    effect: {
      vitality: 2
    }
  },
  {
    name: 'Mana Shield',
    description: '',
    requirements: {

    },
    effect: {
      defense: 2
    }
  },
  {
    name: 'Healing Touch',
    description: '',
    requirements: {

    },
    effect: {
      defense: 1,
      vitality: 1
    }
  },
  {
    name: 'Regeneration',
    description: '',
    requirements: {

    },
    effect: {
      vitality: 2
    }
  },
  {
    name: 'Smoke Screen',
    description: '',
    requirements: {

    },
    effect: {
      defense: 4
    }
  }
  ];


  classes: PlayerClass[] = [{
    name: 'Awakened',
    parent: undefined,
    skills: [],
    levelup:
    {
      attribute_point: 1,
      attribute: {
      }
    }
  }, {
    name: 'Attacker',
    parent: 'Awakened',
    skills: [],
    levelup:
    {
      attribute_point: 1,
      attribute: {
        attack: 1
      }
    }
  }, {
    name: 'Balanced Attacker',
    parent: 'Attacker',
    skills: [],
    levelup:
    {
      attribute_point: 0,
      attribute: {
        attack: 2,
        defense: 1,
        vitality: 1,
        stamina: 1
      }
    }
  }, {
    name: 'Berserker',
    parent: 'Attacker',
    skills: [],
    levelup:
    {
      attribute_point: 1,
      attribute: {
        attack: 3,
        vitality: 1,
        stamina: 1
      }
    }
  }, {
    name: 'Defender',
    parent: 'Awakened',
    skills: [],
    levelup:
    {
      attribute_point: 1,
      attribute: {
        defense: 1
      }
    }
  }, {
    name: 'Balanced Defender',
    parent: 'Defender',
    skills: [],
    levelup:
    {
      attribute_point: 0,
      attribute: {
        defense: 2,
        attack: 1,
        vitality: 1,
        stamina: 1
      }
    }
  }, {
    name: 'Guardian',
    parent: 'Defender',
    skills: [],
    levelup:
    {
      attribute_point: 0,
      attribute: {
        defense: 3,
        vitality: 1,
        stamina: 1
      }
    }
  }];

  traps: Trap[] = [
    {
      name: 'Basic Pit',
      attributes: {
        attack: 1,
        defense: 1
      }
    },
    {
      name: 'Camaflauged Pit',
      attributes: {
        attack: 1,
        defense: 1
      }
    },
    {
      name: 'Falling Net',
      attributes: {
        attack: 2,
        defense: 1
      }
    },
    {
      name: 'Dart',
      attributes: {
        attack: 1,
        defense: 1
      }
    },
    {
      name: 'Poisoned Dart',
      attributes: {
        attack: 2,
        defense: 1
      }
    },
    {
      name: 'Clollapsing Roof',
      attributes: {
        attack: 2,
        defense: 1
      }
    },
    {
      name: 'Spear',
      attributes: {
        attack: 1,
        defense: 1
      }
    }, {
      name: 'Swinging Blades',
      attributes: {
        attack: 1,
        defense: 1
      }
    },
  ]


  monsters: Monster[] = [
    {
      name: 'Wolf',
      prefixes: [
        {
          level: 1,
          name: 'juvenile',
          attributes: {
            attack: 2,
            defense: 1,
            stamina: 1,
            vitality: 1
          }
        },
        {
          level: 2,
          name: 'young',
          attributes: {
            attack: 15,
            defense: 10,
            stamina: 1,
            vitality: 5
          }
        },
        {
          level: 3,
          name: 'adolescent',
          attributes: {
            attack: 120,
            defense: 100,
            stamina: 1,
            vitality: 60
          }
        },
        // {
        //   level: 4,
        //   name: 'young adult',
        //   attributes: {
        //     attack: 7,
        //     defense: 6,
        //     stamina: 1,
        //     vitality: 10
        //   }
        // },
        // {
        //   level: 5,
        //   name: 'adult',
        //   attributes: {
        //     attack: 10,
        //     defense: 10,
        //     stamina: 1,
        //     vitality: 15
        //   }
        // },
        // {
        //   level: 6,
        //   name: 'experienced',
        //   attributes: {
        //     attack: 15,
        //     defense: 15,
        //     stamina: 1,
        //     vitality: 25
        //   }
        // },
        // {
        //   level: 7,
        //   name: 'vetran',
        //   attributes: {
        //     attack: 25,
        //     defense: 25,
        //     stamina: 1,
        //     vitality: 40
        //   }
        // }
      ]
    },
    /*{
      name: 'Snake',
      prefixes: [
        {
          level: 1,
          name: 'juvenile',
          attributes: {
            attack: 3,
            defense: 0,
            vitality: 1
          }
        },
        {
          level: 2,
          name: 'young',
          attributes: {
            attack: 2,
            defense: 2,
            stamina: 1,
            vitality: 1
          }
        },
        {
          level: 3,
          name: 'adolescent',
          attributes: {
            attack: 5,
            defense: 6,
            stamina: 1,
            vitality: 2
          }
        },
        {
          level: 4,
          name: 'young adult',
          attributes: {
            attack: 7,
            defense: 9,
            stamina: 1,
            vitality: 2
          }
        },
        {
          level: 5,
          name: 'adult',
          attributes: {
            attack: 10,
            defense: 15,
            stamina: 1,
            vitality: 3
          }
        },
        {
          level: 6,
          name: 'experienced',
          attributes: {
            attack: 15,
            defense: 15,
            stamina: 1,
            vitality: 25
          }
        },
        {
          level: 7,
          name: 'vetran',
          attributes: {
            attack: 25,
            defense: 30,
            stamina: 1,
            vitality: 5
          }
        }
      ]
    },
     {
       name: 'Slime',
       prefixes: [
         {
           level: 1,
           name: 'juvenile',
           attributes: {
             attack: 3,
             defense: 1,
             vitality: 1
           }
         }
       ]
     },
     {
       name: 'Imp',
       prefixes: [
         {
           level: 1,
           name: 'juvenile',
           attributes: {
             attack: 4,
             defense: 1,
             vitality: 1
           }
         }
       ]
     }*/
  ]

  loot_pool_weight = [
    { id: loot_pools.Junk, weight: 50 },
    { id: loot_pools.Crude, weight: 25 },
    { id: loot_pools.Normal, weight: 15 },
    { id: loot_pools.Magic, weight: 5 },
    { id: loot_pools.Rare, weight: 1 }
  ]

  items: InventoryItem[] = [
    {
      name: 'Experience Crystal',
      loot: loot_pools.Crystal,
      consumable: true,
      price: 100,
      effect_consumed: {
        exp: 100
      }
    },
    {
      name: 'Class Crystal',
      loot: loot_pools.Crystal,
      consumable: false,
      price: 1000,
      effect_consumed: {
      }
    },
    // {
    //   name: 'Health Potion',
    //   consumable: true,
    //   price: 10,
    //   effect_consumed: {
    //     health: 10
    //   }
    // },
    // {
    //   name: 'Energy Potion',
    //   consumable: true,
    //   price: 10,
    //   effect_consumed: {
    //     energy: 10
    //   }
    // },
    // {
    //   name: 'Meat',
    //   consumable: true,
    //   price: 1,
    //   effect_consumed: {
    //     health: 2
    //   }
    // },
    // {
    //   name: 'Bones',
    //   consumable: false,
    //   price: 1
    // },
    {
      name: 'Broken Sword',
      consumable: false,
      loot: loot_pools.Junk,
      equip_slot: 1,
      price: 5,
      effect_equip:
      {
        attack: 1
      },
    },
    {
      name: 'Broken Axe',
      consumable: false,
      loot: loot_pools.Junk,
      equip_slot: 1,
      price: 5,
      effect_equip:
      {
        attack: 1
      },
    },
    {
      name: 'Broken Spear',
      consumable: false,
      loot: loot_pools.Junk,
      equip_slot: 1,
      price: 5,
      effect_equip:
      {
        attack: 1
      },
    },
    // {
    //   name: 'Broken Daggers',
    //   consumable: false,
    //   equip_slot: 1,
    //   price: 1,
    //   effect_equip:
    //   {
    //     attack: 1
    //   },
    // },
    {
      name: 'Broken Shield',
      consumable: false,
      loot: loot_pools.Junk,
      equip_slot: 1,
      price: 5,
      effect_equip:
      {
        defense: 1
      },
    },
    {
      name: 'Crude Shield',
      consumable: false,
      loot: loot_pools.Crude,
      equip_slot: 1,
      price: 15,
      effect_equip:
      {
        defense: 2
      },
    },
    {
      name: 'Great Shield',
      consumable: false,
      loot: loot_pools.Normal,
      equip_slot: 1,
      price: 25,
      effect_equip:
      {
        defense: 3,
        vitality: 2
      },
    },
    {
      name: 'Crude Sword',
      consumable: false,
      loot: loot_pools.Crude,
      equip_slot: 1,
      price: 15,
      effect_equip:
      {
        attack: 2
      },
    },
    {
      name: 'Broken Helmet',
      consumable: false,
      loot: loot_pools.Junk,
      equip_slot: 2,
      price: 5,
      effect_equip:
      {
        defense: 1
      },
    },
    {
      name: 'Crude Helmet',
      consumable: false,
      loot: loot_pools.Crude,
      equip_slot: 2,
      price: 15,
      effect_equip:
      {
        defense: 2
      },
    },
    {
      name: 'Broken Bracers',
      consumable: false,
      loot: loot_pools.Junk,
      equip_slot: 3,
      price: 5,
      effect_equip:
      {
        defense: 1
      },
    },
    {
      name: 'Crude Bracers',
      consumable: false,
      loot: loot_pools.Crude,
      equip_slot: 3,
      price: 15,
      effect_equip:
      {
        defense: 2
      },
    },
    {
      name: 'Spiked Bracers',
      consumable: false,
      loot: loot_pools.Normal,
      equip_slot: 3,
      price: 30,
      effect_equip:
      {
        defense: 2,
        attack: 1
      },
    },
    {
      name: 'Cloth Shirt',
      consumable: false,
      loot: loot_pools.Junk,
      equip_slot: 4,
      price: 5
    },
    {
      name: 'Leather Armour',
      consumable: false,
      loot: loot_pools.Crude,
      equip_slot: 4,
      price: 25,
      effect_equip: {
        defense: 2
      }
    },
    {
      name: 'Spiked Leather Armour',
      consumable: false,
      loot: loot_pools.Normal,
      equip_slot: 4,
      price: 25,
      effect_equip: {
        defense: 4,
        attack: 1
      }
    },
    {
      name: 'Hard Spiked Leather Armour',
      consumable: false,
      loot: loot_pools.Magic,
      equip_slot: 4,
      price: 25,
      effect_equip: {
        defense: 8,
        attack: 3,
        vitality: 2
      }
    },
    {
      name: 'Cloth Gloves',
      consumable: false,
      loot: loot_pools.Junk,
      equip_slot: 3,
      price: 5
    },
    {
      name: 'Cloth Boots',
      consumable: false,
      loot: loot_pools.Junk,
      equip_slot: 5,
      price: 5
    },
    {
      name: 'Leather Boots',
      consumable: false,
      loot: loot_pools.Crude,
      equip_slot: 5,
      price: 15,
      effect_equip: {
        defense: 1,
        stamina: 1
      }
    },
    {
      name: 'Swift Boots',
      consumable: false,
      loot: loot_pools.Normal,
      equip_slot: 5,
      price: 20,
      effect_equip: {
        stamina: 2
      }
    },
    {
      name: 'Quick Boots',
      consumable: false,
      loot: loot_pools.Magic,
      equip_slot: 5,
      price: 50,
      effect_equip: {
        defense: 1,
        stamina: 3
      }
    },
    {
      name: 'Crude Stamina Ring',
      consumable: false,
      loot: loot_pools.Crude,
      equip_slot: 6,
      price: 50,
      effect_equip: {
        stamina: 1
      }
    },
    {
      name: 'Stamina Ring',
      consumable: false,
      loot: loot_pools.Normal,
      equip_slot: 6,
      price: 80,
      effect_equip: {
        stamina: 2
      }
    },
    {
      name: 'Crude vitality Ring',
      consumable: false,
      loot: loot_pools.Crude,
      equip_slot: 6,
      price: 50,
      effect_equip: {
        vitality: 1
      }
    },
    {
      name: 'vitality Ring',
      consumable: false,
      loot: loot_pools.Normal,
      equip_slot: 6,
      price: 80,
      effect_equip: {
        vitality: 2
      }
    },
    {
      name: 'Enhancement Ring',
      consumable: false,
      loot: loot_pools.Magic,
      equip_slot: 6,
      price: 500,
      effect_equip: {
        vitality: 4,
        stamina: 4
      },
    },
    {
      name: 'Rainbow Ring',
      consumable: false,
      loot: loot_pools.Rare,
      equip_slot: 6,
      price: 2000,
      effect_equip: {
        vitality: 8,
        stamina: 8,
        attack: 8,
        defense: 8
      }
    },
  ]

  inventory_dictonary: Record<string, InventoryItem> = {};

  current_players: string[] = [];


  constructor() {
    this.items.forEach(c => this.inventory_dictonary[c.name] = c);
  }
}
